const E = {
  'My Account': 'My Account',
  'Change Password': 'Change Password',
  'Old Password': 'Temporary or Current Password',
  'New Password': 'New Password',
  'Confirm New Password': 'Confirm New Password',
  PasswordRequirementsText:
    'Your password must be 8-15 characters long, containing at least 1 upper case, 1 lower case character and at least 1 special character, limited to: @ $ ! % * ? & , as well as 1 numeric value.',
  Settings: 'Settings',
  PasswordChanged: 'Your password has successfully been changed.',
  'Save Password': 'Save Password',
  'Preferred Date Format': 'Preferred Date Format',
  'Preferred Time Format': 'Preferred Time Format',
  'Display Non Analytical Jobs': 'Display Non Analytical Jobs',
  'Suppress Duplicates': 'Suppress Duplicates',
  Language: 'Language',
  'Line of Business': 'Line of Business',
  Phone: 'Phone',
  'Cell Phone': 'Cell Phone',
  'Save Settings': 'Save Settings',
  'Account Contacts': 'Account Contacts',
  'Company Name': 'Company Name',
  'Account Manager': 'Account Manager',
  'Project Manager': 'Project Manager',
  'System Administrators': 'System Administrators',

  Environmental: 'Environmental',
  Food: 'Food',
  'Industrial Hygiene': 'Industrial Hygiene',
  Petroleum: 'Petroleum',
  ChangePasswordMessage:
    'You have logged into the Customer Portal for the first time since updating your password. You have been redirected to this page to change your password. The temporary password sent to you will expire in 1 week.',
  PasswordToExpireMessage: 'Your password expires on {expiryDate}. To ensure uninterrupted service, please change your password now.',
  LengthRequired: "8 to 15 characters",
  UpperCaseRequired: "1 upper case letter",
  LowerCaseRequired: "1 lower case letter",
  NumberRequired: "1 number",
  SpecialCharacterRequired: "1 valid special character (limited to ! @ $ % & * ?)",
  PasswordRequirements: "Password Requirements",
  NewPasswordRequirement: "New password does not meet the requirements.",
};

const F = {
  'My Account': 'Mon compte',
  PasswordChanged: 'Votre mot de passe a bien été changé.',
  'Change Password': 'Changer le mot de passe',
  'Old Password': 'Mot de passe temporaire ou ancien',
  'New Password': 'Nouveau mot de passe',
  'Confirm New Password': 'Confirmez le nouveau mot de passe',
  PasswordRequirementsText:
    'Votre mot de passe doit comporter entre 8 et 15 caractères alphanumériques et contenir au moins une majuscule, une minuscule et au moins 1 caractère spécial, limité à: @ $ ! % *? & et un chiffre.',
  Settings: 'Paramètres',
  'Save Password': 'Enregistrer le mot de passe',
  'Preferred Date Format': 'Format de date préféré',
  'Preferred Time Format': 'Format d’heure préféré',
  'Display Non Analytical Jobs': 'Afficher les dossiers sans analyse',
  'Suppress Duplicates': 'Supprimer les doublons',
  Language: 'Langues',
  'Line of Business': 'Secteur d’activité',
  Phone: 'Téléphone',
  'Cell Phone': 'Cellulaire',
  'Save Settings': 'Enregistrer les paramètres',
  'Account Contacts': 'Contacts pour le compte',
  'Company Name': 'Nom de l’entreprise',
  'Account Manager': 'Gestionnaire de compte',
  'Project Manager': 'Chargé de projet',
  'System Administrators': 'Administrateur système',

  Environmental: 'Environnement',
  Food: 'Alimentaire',
  'Industrial Hygiene': 'Hygiène industrielle',
  Petroleum: 'Pétrole',
  ChangePasswordMessage:
    'Vous avez connecté au portail client pour la première fois depuis la mise à jour de votre mot de passe. Vous avez été redirigé vers cette page pour changer votre mot de passe. Le mot de passe temporaire qui vous est envoyé va expirer dans 1 semaine',
  PasswordToExpireMessage: 'Votre mot de passe expire le {expiryDate}. Pour assurer un service ininterrompu, veuillez changer votre mot de passe maintenant.',
  LengthRequired: "8 à 15 caractères",
  UpperCaseRequired: "1 lettre majuscule",
  LowerCaseRequired: "1 lettre minuscule",
  NumberRequired: "1 chiffre",
  SpecialCharacterRequired: "1 caractère spécial valide (limité à ! @ $ % & * ?)",
  PasswordRequirements: "Exigences relatives au mot de passe.",
  NewPasswordRequirement: "Le nouveau mot de passe ne répond pas aux exigences.",
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/myAccounts.js